// Axios and configuration
import Axios from "axios"
// Interfaces
import type I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse"
import AxiosConfig from "src/utilities/AxiosConfig"
// Utilities
import snackBar from "src/utilities/snackBar/SnackBar"
import type { I_ApprovalLeaseRequest } from "../types"

/**
 * Fetches lease approval requests initiated by a specific user.
 *
 * @param createdBy - The user who initiated the requests
 * @returns An array of lease approval requests, or an empty array on failure
 */
const GetLeaseApprovalRequests = async (
	createdBy: number,
): Promise<I_ApprovalLeaseRequest[]> => {
	try {
		const response = await Axios.get<I_BaseAPIResponse<I_ApprovalLeaseRequest[]>>(
			`${process.env.REACT_APP_API_URL}/api/approval/lease/requests?createdBy=${createdBy}`,
			AxiosConfig.configValue("min"),
		)

		if (response.data.HasError) {
			snackBar({
				type: "error",
				text: response.data.ErrorMessage,
				timeout: 4000,
			})
			return []
		}

		return response.data.Data
	} catch (error) {
		console.error("GetLeaseApprovalRequests failed:", error)
		snackBar({
			type: "error",
			text: "Failed to get lease approval requests",
			timeout: 4000,
		})
		return []
	}
}

export default GetLeaseApprovalRequests
